import AboutModal from './AboutModal.json';
import Buttons from './Buttons.json';
import CaptureViewportModal from './CaptureViewportModal.json';
import CineDialog from './CineDialog.json';
import Colormaps from './Colormaps.json';
import Common from './Common.json';
import DataRow from './DataRow.json';
import DataSourceConfiguration from './DataSourceConfiguration.json';
import DatePicker from './DatePicker.json';
import ErrorBoundary from './ErrorBoundary.json';
import Header from './Header.json';
import HotkeysValidators from './HotkeysValidators.json';
import Hps from './Hps.json';
import MeasurementTable from './MeasurementTable.json';
import Messages from './Messages.json';
import Modals from './Modals.json';
import Modes from './Modes.json';
import Onboarding from './Onboarding.json';
import PanelSUV from './PanelSUV.json';
import PatientInfo from './PatientInfo.json';
import ROIThresholdConfiguration from './ROIThresholdConfiguration.json';
import SegmentationPanel from './SegmentationPanel.json';
import SidePanel from './SidePanel.json';
import StudyBrowser from './StudyBrowser.json';
import StudyItem from './StudyItem.json';
import StudyList from './StudyList.json';
import ThumbnailTracked from './ThumbnailTracked.json';
import ToolbarLayoutSelector from './ToolbarLayoutSelector.json';
import Tools from './Tools.json';
import ToolTip from './ToolTip.json';
import TooltipClipboard from './TooltipClipboard.json';
import TrackedCornerstoneViewport from './TrackedCornerstoneViewport.json';
import USAnnotationPanel from './USAnnotationPanel.json';
import UserPreferencesModal from './UserPreferencesModal.json';
import ViewportDownloadForm from './ViewportDownloadForm.json';
import WindowLevelActionMenu from './WindowLevelActionMenu.json';

export default { 
  'test-LNG': {
    AboutModal,
    Buttons,
    CaptureViewportModal,
    CineDialog,
    Colormaps,
    Common,
    DataRow,
    DataSourceConfiguration,
    DatePicker,
    ErrorBoundary,
    Header,
    HotkeysValidators,
    Hps,
    MeasurementTable,
    Messages,
    Modals,
    Modes,
    Onboarding,
    PanelSUV,
    PatientInfo,
    ROIThresholdConfiguration,
    SegmentationPanel,
    SidePanel,
    StudyBrowser,
    StudyItem,
    StudyList,
    ThumbnailTracked,
    ToolbarLayoutSelector,
    Tools,
    ToolTip,
    TooltipClipboard,
    TrackedCornerstoneViewport,
    USAnnotationPanel,
    UserPreferencesModal,
    ViewportDownloadForm,
    WindowLevelActionMenu,
  }
};
